import script from "./RealizedOrdersScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RealizedOrdersScreen.vue?vue&type=script&setup=true&lang=js"

import "./RealizedOrdersScreen.vue?vue&type=style&index=0&id=3d686a77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d686a77"]])

export default __exports__